export default __webpack_public_path__ + "static/media/daylotts1000000_icon.5f06c75b.png";